<template>
    <div class="pt-3 px-3">
        <form-modal
            :id="componente"
            placeholder-button="Inserir" 
            :fields="colunas"
            :values="dadosCalculados"
            
            @ok="salvar"
            @cancel="inicializarForm"
            @edit="editar"
            @remove="remover"
            ref="modal"
            :titleModal="configuracao.titulo"

            :create="permissao.c"
            :read="permissao.r"
            :update="permissao.u"
            :remove="permissao.d"
            :controles="!aprovada"
        >
            <template #modal>
                <component 
                    :is='componente' 
                    ref="form" 
                    :form="form"
                    :duracao="duracao"
                    :nome-coluna-tipo="configuracao.nomeColunaTipo"
                    :tipo-label="configuracao.tipo.label"
                    :tipo-options="configuracao.tipo.options"
                />
            </template>
        </form-modal>
    </div>
</template>
<script>

import FormModal from "@/components/modal/FormModal";
import PropostaService from "@/common/services/proposta/proposta.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import config from "./config";
import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: "PropostaRubrica",
    mixins: [AlertasMixin],
    props: {
        propostaId: {
            required: true
        },
        duracao: {
            required: true
        },
        aprovada: {
            type: Boolean,
            default: false
        },
        componente: {
            type: String,
            default: null
        },
        chavePermissao: {
            type: String,
            default: null
        }
    },
    components: {
        FormModal,
        'st' : () => import('./modal/previsto'),
        'mc' : () => import('./modal/previsto'),
        'mpe' : () => import('./modal/previsto'),
        'vd' : () => import('./modal/vd'),
        'ou' : () => import('./modal/previsto'),
    },
    data: () =>({
        fields : [
            { key: "tipoServico", label: "Tipo",
                formatter: (value) => {
                    if (value) return  helpers.getTipoServico(value).text;
                },
            },
            { key: "detalhamento", label:"Detalhamento"},
            { key: "justificativa", label: "Justificativa", },
            { key: "valor", label: "Custo",
                formatter: (value) => {
                    if (value) return helpers.formatarValor(value);
                },
            },
            { key: "actions", label: "Ações"} 
        ],

        form : null,
        dados : [],
    }),
    methods:{
        montar : function(){
            this.inicializarForm();
            this.buscar();
        },  
        salvar: function(){
            
            this.confirmar("Deseja salvar despesa?").then(confirmado => {
                if(!confirmado) return;

                if(this.$refs.form.validateState() == false) return;

                this.$store.dispatch(START_LOADING);

                let form = cloneDeep(this.form);
                
                //todas as possibilidades de ids
                form.propostaId = this.propostaId;
                form.propostaEmpresaProponenteId = this.propostaId;
                form.propostaEmpresaExecutoraId = this.propostaId;
                form.propostaEmpresaCooperadaId = this.propostaId;

                if(form.valor) form.valor = helpers.removerValor(form.valor);
                if(form.valorUnitario) form.valorUnitario = helpers.removerValor(form.valorUnitario);

                PropostaService.salvarDespesa(form, this.configuracao.endpoint).then(() => {
                    this.alertaSucesso("Despesa salva com sucesso!").then(() => {
                        this.$refs.modal.closeModal();
                        this.montar();
                    });                    
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else   
                        this.alertaErro("Erro ao salvar");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });


        },

        editar: function(despesa){
            this.form = cloneDeep(despesa);
            if(this.form.valor) this.form.valor = helpers.formatarValor(this.form.valor);
            if(this.form.valorUnitario) this.form.valorUnitario = helpers.formatarValor(this.form.valorUnitario);
            this.form[this.configuracao.nomeId] = this.form.id;
            this.$refs.modal.openModal();
        },

        remover: function(despesa){
            this.confirmar("Deseja excluir despesa?").then(confirmado => {
                 if(!confirmado) return;

                let form = {};
                form[this.configuracao.nomeId] = despesa.id;
                form.propostaId = this.propostaId

                this.$store.dispatch(START_LOADING);

                PropostaService.removerDespesa(form, this.configuracao.endpoint).then(() => {
                    this.alertaSucesso("Despesa excluida com sucesso!").then(() => {
                        this.montar();
                    });                    
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else   
                        this.alertaErro("Erro ao excluir");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },

        buscar : function(){
            this.$store.dispatch(START_LOADING);
            PropostaService.buscarDespesa(this.propostaId, this.configuracao.endpoint).then(res => {
                this.dados = res.data.data;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },

        inicializarForm : function(){
            this.form = cloneDeep(this.configuracao.form);
        },
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao'](this.chavePermissao);
        },
        dadosCalculados: function(){
            let valores = cloneDeep(this.dados);
            valores.push({
                id:-1,
                [this.configuracao.nomeColunaTipo]: -1,
                valor: this.dados.reduce((total,el) => total + (el.valor),0),
                _rowVariant: 'warning'
            });
            return valores;
        },
        configuracao : function(){
            return config[this.componente];
        },
        colunas : function(){
            let colunas = [
                {
                    key : this.configuracao.nomeColunaTipo,
                    label: "Tipo",
                    formatter: (value) => {
                        if (value) return  helpers.getEnum(value).text;
                    },
                    
                }
            ];

            colunas.push(...this.configuracao.colunas)
            return colunas;
        }
    }
}
</script>
<style lang="">
    
</style>